export default __webpack_public_path__ + "static/media/surgical-scheduling-home.de23e59c.svg";